import MIOService from "../services/MIOService";

const getDefaultState = () => ({
  studentCount: {},
  teacherCount: {},
  schoolCount: {},
  coordinatorCount: {},
  moduleVisitCount: {},
  maintenanceVisitCount: {},
  moduleVisitCountCountry: {},
  maintenanceVisitCountCountry: {},
  groupCount1: {},
  groupCount2: {},
  trainerGroups: {},
  trainerVisits: {},
  schoolLocations: {},
  groupsYear: {},
  groupsMonth: {},
  visitsYear: {},
  visitsMonth: {},
  modulesMonth: {},
  modulesYear: {},
  workshopsMonth: {},
  workshopsYear: {},
  studentCountsYear: {},
  certificates: {},
  parentCertificates: {},
  parentCertificatesDistrict: {},
  classroomAttainment: {},
  visitsYearTeacher: {},
  visitsYearSchool: {},
  trainerCoordinatorPerformance: {},
  remuneration: {},
  classroomAttainmentSmall: {},
  covidObs: {},
  covidObsSmall: {},
  dataConsentMonth: {},
  dataConsentYear: {},
  dataConsentYearDistrict: {},
  studentCountsMonth: {},
  teacherCountsMonth: {},
  schoolCountsMonth: {},
  studentsCountryYear: {},
  schoolsCountryYear: {},
  teachersCountryYear: {},
  cumStudentsCountryYear: {},
  cumSchoolsCountryYear: {},
  cumTeachersCountryYear: {},
  cumTeachersPhaseCountryYear: {},
  teachersUnderMaintenance: {},
  programmePhaseTeachers: {},
  activeProgrammePhaseTeachers: {},
  workshopCount: {},
  teachersLastVisitPerGroup: {},
  groupsStartYear: {},
  modulesTaughtYear: {},
  annualCumulativeInteractionsData: {},
});

const mio = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    studentCount(state, val) {
      Object.assign(state.studentCount, val);
    },
    teacherCount(state, val) {
      Object.assign(state.teacherCount, val);
    },
    schoolCount(state, val) {
      Object.assign(state.schoolCount, val);
    },
    coordinatorCount(state, val) {
      Object.assign(state.coordinatorCount, val);
    },
    moduleVisitCount(state, val) {
      Object.assign(state.moduleVisitCount, val);
    },
    maintenanceVisitCount(state, val) {
      Object.assign(state.maintenanceVisitCount, val);
    },
    moduleVisitCountCountry(state, val) {
      Object.assign(state.moduleVisitCountCountry, val);
    },
    maintenanceVisitCountCountry(state, val) {
      Object.assign(state.maintenanceVisitCountCountry, val);
    },
    groupCount1(state, val) {
      Object.assign(state.groupCount1, val);
    },
    groupCount2(state, val) {
      Object.assign(state.groupCount2, val);
    },
    trainerGroups(state, val) {
      Object.assign(state.trainerGroups, val);
    },
    trainerVisits(state, val) {
      Object.assign(state.trainerVisits, val);
    },
    schoolLocations(state, val) {
      Object.assign(state.schoolLocations, val);
    },
    groupsYear(state, val) {
      Object.assign(state.groupsYear, val);
    },
    groupsMonth(state, val) {
      Object.assign(state.groupsMonth, val);
    },
    visitsYear(state, val) {
      Object.assign(state.visitsYear, val);
    },
    visitsMonth(state, val) {
      Object.assign(state.visitsMonth, val);
    },
    modulesYear(state, val) {
      Object.assign(state.modulesYear, val);
    },
    modulesMonth(state, val) {
      Object.assign(state.modulesMonth, val);
    },
    workshopsYear(state, val) {
      Object.assign(state.workshopsYear, val);
    },
    workshopsMonth(state, val) {
      Object.assign(state.workshopsMonth, val);
    },
    studentCountsYear(state, val) {
      Object.assign(state.studentCountsYear, val);
    },
    certificates(state, val) {
      Object.assign(state.certificates, val);
    },
    parentCertificates(state, val) {
      Object.assign(state.parentCertificates, val);
    },
    parentCertificatesDistrict(state, val) {
      Object.assign(state.parentCertificatesDistrict, val);
    },
    classroomAttainment(state, val) {
      Object.assign(state.classroomAttainment, val);
    },
    visitsYearTeacher(state, val) {
      Object.assign(state.visitsYearTeacher, val);
    },
    visitsYearSchool(state, val) {
      Object.assign(state.visitsYearSchool, val);
    },
    trainerCoordinatorPerformance(state, val) {
      Object.assign(state.trainerCoordinatorPerformance, val);
    },
    remuneration(state, val) {
      Object.assign(state.remuneration, val);
    },
    classroomAttainmentSmall(state, val) {
      Object.assign(state.classroomAttainmentSmall, val);
    },
    covidObs(state, val) {
      Object.assign(state.covidObs, val);
    },
    covidObsSmall(state, val) {
      Object.assign(state.covidObsSmall, val);
    },
    dataConsentMonth(state, val) {
      Object.assign(state.dataConsentMonth, val);
    },
    dataConsentYear(state, val) {
      Object.assign(state.dataConsentYear, val);
    },
    dataConsentYearDistrict(state, val) {
      Object.assign(state.dataConsentYearDistrict, val);
    },
    studentCountsMonth(state, val) {
      Object.assign(state.studentCountsMonth, val);
    },
    teacherCountsMonth(state, val) {
      Object.assign(state.teacherCountsMonth, val);
    },
    schoolCountsMonth(state, val) {
      Object.assign(state.schoolCountsMonth, val);
    },
    studentsCountryYear(state, val) {
      Object.assign(state.studentsCountryYear, val);
    },
    schoolsCountryYear(state, val) {
      Object.assign(state.schoolsCountryYear, val);
    },
    teachersCountryYear(state, val) {
      Object.assign(state.teachersCountryYear, val);
    },
    cumStudentsCountryYear(state, val) {
      Object.assign(state.cumStudentsCountryYear, val);
    },
    cumSchoolsCountryYear(state, val) {
      Object.assign(state.cumSchoolsCountryYear, val);
    },
    cumTeachersCountryYear(state, val) {
      Object.assign(state.cumTeachersCountryYear, val);
    },
    cumTeachersPhaseCountryYear(state, val) {
      Object.assign(state.cumTeachersPhaseCountryYear, val);
    },
    coordinatorCount(state, val) {
      Object.assign(state.coordinatorCount, val);
    },
    teachersUnderMaintenance(state, val) {
      Object.assign(state.teachersUnderMaintenance, val);
    },
    programmePhaseTeachers(state, val) {
      Object.assign(state.programmePhaseTeachers, val);
    },
    activeProgrammePhaseTeachers(state, val) {
      Object.assign(state.activeProgrammePhaseTeachers, val);
    },
    workshopCount(state, val) {
      Object.assign(state.workshopCount, val);
    },
    teachersLastVisitPerGroup(state, val) {
      Object.assign(state.teachersLastVisitPerGroup, val);
    },
    groupsStartYear(state, val) {
      Object.assign(state.groupsStartYear, val);
    },
    modulesTaughtYear(state, val) {
      Object.assign(state.modulesTaughtYear, val);
    },
    annualCumulativeInteractionsData(state, val) {
      Object.assign(state.annualCumulativeInteractionsData, val);
    }
  },
  actions: {
    async GET_STUDENT_COUNT(context) {
      const request = await MIOService.getStudentCounts();
      const data = request.data.results;
      context.commit("studentCount", data);
    },
    async GET_TEACHER_COUNT(context) {
      const request = await MIOService.getTeacherCounts();
      const data = request.data.results;
      context.commit("teacherCount", data);
    },
    async GET_COORDINATOR_COUNT(context) {
      const request = await MIOService.getCoordinatorCounts();
      const data = request.data.results;
      context.commit("coordinatorCount", data);
    },
    async GET_SCHOOL_COUNT(context) {
      const request = await MIOService.getSchoolCounts();
      const data = request.data.results;
      context.commit("schoolCount", data);
    },
    async GET_MODULE_VISIT_COUNT(context) {
      const request = await MIOService.getVisitCounts("Module");
      const data = request.data.results;
      context.commit("moduleVisitCount", data);
    },
    async GET_MAINTENANCE_VISIT_COUNT(context) {
    const request = await MIOService.getVisitCounts("Maintenance");
      const data = request.data.results;
      context.commit("maintenanceVisitCount", data);
    },
    async GET_MODULE_VISIT_COUNT_COUNTRY(context) {
      const request = await MIOService.getVisitCountsCountry("Module");
      const data = request.data.results;
      context.commit("moduleVisitCountCountry", data);
    },
    async GET_MAINTENANCE_VISIT_COUNT_COUNTRY(context) {
      const request = await MIOService.getVisitCountsCountry("Maintenance");
      const data = request.data.results;
      context.commit("maintenanceVisitCountCountry", data);
    },
    async GET_GROUP_COUNT_1(context) {
      const request = await MIOService.getGroupCounts1();
      const data = request.data.results;
      context.commit("groupCount1", data);
    },
    async GET_GROUP_COUNT_2(context) {
      const request = await MIOService.getGroupCounts2();
      const data = request.data.results;
      context.commit("groupCount2", data);
    },
    async GET_TRAINER_GROUPS(context) {
      const request = await MIOService.getTrainerGroups();
      const data = request.data.results;
      context.commit("trainerGroups", data);
    },
    async GET_TRAINER_VISITS(context) {
      const request = await MIOService.getTrainerVisits();
      const data = request.data.results;
      context.commit("trainerVisits", data);
    },
    async GET_SCHOOL_LOCATIONS(context) {
      const request = await MIOService.getSchoolLocations();
      const data = request.data.results;
      context.commit("schoolLocations", data);
    },
    async GET_GROUPS_YEAR(context) {
      const request = await MIOService.getGroupsYear();
      const data = request.data.results;
      context.commit("groupsYear", data);
    },
    async GET_GROUPS_MONTH(context) {
      const request = await MIOService.getGroupsMonth();
      const data = request.data.results;
      context.commit("groupsMonth", data);
    },
    async GET_VISITS_YEAR(context) {
      const request = await MIOService.getVisitsYear();
      const data = request.data.results;
      context.commit("visitsYear", data);
    },
    async GET_VISITS_MONTH(context) {
      const request = await MIOService.getVisitsMonth();
      const data = request.data.results;
      context.commit("visitsMonth", data);
    },
    async GET_MODULES_YEAR(context) {
      const request = await MIOService.getModulesYear();
      const data = request.data.results;
      context.commit("modulesYear", data);
    },
    async GET_MODULES_MONTH(context) {
      const request = await MIOService.getModulesMonth();
      const data = request.data.results;
      context.commit("modulesMonth", data);
    },
    async GET_WORKSHOPS_YEAR(context) {
      const request = await MIOService.getWorkshopsYear();
      const data = request.data.results;
      context.commit("workshopsYear", data);
    },
    async GET_WORKSHOPS_MONTH(context) {
      const request = await MIOService.getWorkshopsMonth();
      const data = request.data.results;
      context.commit("workshopsMonth", data);
    },
    async GET_STUDENT_COUNTS_YEAR(context) {
      const request = await MIOService.getStudentCountsYear();
      const data = request.data.results;
      context.commit("studentCountsYear", data);
    },
    async GET_CERTIFICATES(context) {
      const request = await MIOService.getCertificates();
      const data = request.data.results;
      context.commit("certificates", data);
    },
    async GET_PARENT_CERTIFICATES(context) {
      const request = await MIOService.getParentCertificates();
      const data = request.data.results;
      context.commit("parentCertificates", data);
    },
    async GET_PARENT_CERTIFICATES_DISTRICT(context) {
      const request = await MIOService.getParentCertificatesDistrict();
      const data = request.data.results;
      context.commit("parentCertificatesDistrict", data);
    },
    async GET_CLASSROOM_ATTAINMENT(context, payload={}) {
      const {fromDate=false} = payload;
      const request = await MIOService.getClassroomAttainment(fromDate);
      const data = request.data.results;
      context.commit("classroomAttainment", data);
    },
    async GET_VISITS_YEAR_TEACHER(context) {
      const request = await MIOService.getVisitsYearTeacher();
      const data = request.data.results;
      context.commit("visitsYearTeacher", data);
    },
    async GET_VISITS_YEAR_SCHOOL(context) {
      const request = await MIOService.getVisitsYearSchool();
      const data = request.data.results;
      context.commit("visitsYearSchool", data);
    },
    async GET_TRAINER_COORDINATOR_PERFORMANCE(context) {
      const request = await MIOService.getTrainerCoordinatorPerformance();
      const data = request.data.results;
      context.commit("trainerCoordinatorPerformance", data);
    },
    async GET_REMUNERATION(context) {
      const request = await MIOService.getRemuneration();
      const data = request.data.results;
      context.commit("remuneration", data);
    },
    async GET_CLASSROOM_ATTAINMENT_SMALL(context, payload={}) {
      const {fromDate=false, toDate=false} = payload;
      const request = await MIOService.getClassroomAttainmentSmall(fromDate, toDate);
      const data = request.data.results;
      context.commit("classroomAttainmentSmall", data);
    },
    async GET_COVID_OBS(context) {
      const request = await MIOService.getCovidObs();
      const data = request.data.results;
      context.commit("covidObs", data);
    },
    async GET_COVID_OBS_SMALL(context) {
      const request = await MIOService.getCovidObsSmall();
      const data = request.data.results;
      context.commit("covidObsSmall", data);
    },
    async GET_DATA_CONSENT_MONTH(context) {
      const request = await MIOService.getDataConsentMonth();
      const data = request.data.results;
      context.commit("dataConsentMonth", data);
    },
    async GET_DATA_CONSENT_YEAR(context) {
      const request = await MIOService.getDataConsentYear();
      const data = request.data.results;
      context.commit("dataConsentYear", data);
    },
    async GET_DATA_CONSENT_YEAR_DISTRICT(context) {
      const request = await MIOService.getDataConsentYearDistrict();
      const data = request.data.results;
      context.commit("dataConsentYearDistrict", data);
    },
    async GET_STUDENT_COUNTS_MONTH(context) {
      const request = await MIOService.getStudentCountsMonth();
      const data = request.data.results;
      context.commit("studentCountsMonth", data);
    },
    async GET_TEACHER_COUNTS_MONTH(context) {
      const request = await MIOService.getTeacherCountsMonth();
      const data = request.data.results;
      context.commit("teacherCountsMonth", data);
    },
    async GET_SCHOOL_COUNTS_MONTH(context) {
      const request = await MIOService.getSchoolCountsMonth();
      const data = request.data.results;
      context.commit("schoolCountsMonth", data);
    },
    async GET_STUDENTS_COUNTRY_YEAR(context) {
      const request = await MIOService.getStudentsCountryYear();
      const data = request.data.results;
      context.commit("studentsCountryYear", data);
    },
    async GET_SCHOOLS_COUNTRY_YEAR(context) {
      const request = await MIOService.getSchoolsCountryYear();
      const data = request.data.results;
      context.commit("schoolsCountryYear", data);
    },
    async GET_TEACHERS_COUNTRY_YEAR(context) {
      const request = await MIOService.getTeachersCountryYear();
      const data = request.data.results;
      context.commit("teachersCountryYear", data);
    },
    async GET_CUM_STUDENTS_COUNTRY_YEAR(context) {
      const request = await MIOService.getCumStudentsCountryYear();
      const data = request.data.results;
      context.commit("cumStudentsCountryYear", data);
    },
    async GET_CUM_SCHOOLS_COUNTRY_YEAR(context) {
      const request = await MIOService.getCumSchoolsCountryYear();
      const data = request.data.results;
      context.commit("cumSchoolsCountryYear", data);
    },
    async GET_CUM_TEACHERS_COUNTRY_YEAR(context) {
      const request = await MIOService.getCumTeachersCountryYear();
      const data = request.data.results;
      context.commit("cumTeachersCountryYear", data);
    },
    async GET_CUM_TEACHERS_PHASE_COUNTRY_YEAR(context) {
      const request = await MIOService.getCumTeachersPhaseCountryYear();
      const data = request.data.results;
      context.commit("cumTeachersPhaseCountryYear", data);
    },
    async GET_COORDINATOR_COUNT(context) {
      const request = await MIOService.getCoordinatorCounts();
      const data = request.data.results;
      context.commit("coordinatorCount", data);
    },
    async GET_TEACHERS_UNDER_MAINTENANCE(context) {
      const request = await MIOService.getTeachersUnderMaintenance();
      const data = request.data.results;
      context.commit("teachersUnderMaintenance", data);
    },
    async GET_PROGRAMME_PHASE_TEACHERS(context) {
      const request = await MIOService.getProgrammePhaseTeachers();
      const data = request.data.results;
      context.commit("programmePhaseTeachers", data);
    },
    async GET_ACTIVE_PROGRAMME_PHASE_TEACHERS(context, payload={}) {
      const {fromDate=false, groupByPeriod=false} = payload;
      const request = await MIOService.getActiveProgrammePhaseTeachers(fromDate, groupByPeriod);
      const data = request.data.results;
      context.commit("activeProgrammePhaseTeachers", data);
    },
    async GET_WORKSHOP_COUNT(context) {
      const request = await MIOService.getWorkshopCounts();
      const data = request.data.results;
      context.commit("workshopCount", data);
    },
    async GET_TEACHERS_LAST_VISIT_PER_GROUP(context) {
      const request = await MIOService.getTeachersLastVisitPerGroup();
      const data = request.data.results;
      context.commit("teachersLastVisitPerGroup", data);
    },
    async GET_GROUPS_START_YEAR(context) {
      const request = await MIOService.getGroupsByStartYear();
      const data = request.data.results;
      context.commit("groupsStartYear", data);
    },
    async GET_MODULES_TAUGHT_YEAR(context) {
      const request = await MIOService.getModulesTaughtByYear();
      const data = request.data.results;
      context.commit("modulesTaughtYear", data);
    },
    async GET_ANNUAL_CUMULATIVE_INTERACTIONS_DATA(context) {
      const request = await MIOService.getAnnualCumulativeInteractionsData();
      const data = request.data.results;
      context.commit("annualCumulativeInteractionsData", data);
    },
    async RESET_STATE(context) {
      await context.commit("resetState");
    },
  },
  getters: {},
};

export default mio;
